import { Injectable } from "@angular/core";
@Injectable()
export class RenewLicense {
    accountId: number;
    reason: String;
    duration: number;
}
